import { html } from 'lit';
import type { SvgIcon } from '../entities';

export const pimDam: SvgIcon = {
  key: '0f419e45-8951-499b-9704-60116daeb701',
  icon: html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--stroke, var(--uui-color-default))"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M3 5V19A9 3 0 0 0 21 19V5" />
      <path d="M3 12A9 3 0 0 0 21 12" />
    </svg>
  `,
};
